import * as React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

type Props = {
    onPrimaryCtaClick: () => void;
    isCreating: boolean;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='Welcome to your SMS drip sequences page'
            subtitle='Drip sequences and the messages they contain will appear here'
            detailTextBullets={[
                'Create a drip sequence to automatically send a series of text messages over time',
                'Use automated start triggers to start sending your drip sequences at exactly the right moment',
                'Set up a goal for your drip sequence and automate a next step in Nutshell when a recipient meets the goal',
            ]}
            cta={
                <SaveButton
                    variant='primary'
                    size='big'
                    // @ts-expect-error
                    onClick={props.onPrimaryCtaClick}
                    isSaving={props.isCreating}
                    buttonText='Create new drip sequence'
                    savingText='Creating drip sequence'
                    successText='Drip sequence created'
                />
            }
            icon={
                <div style={{width: 240, paddingRight: 24}}>
                    <Illustration src='sms-drip-sequence' width='100%' height='100%' />
                </div>
            }
        />
    );
}
